import React from "react"
import {
  useCanRedo, useCanUndo, useRedo, useUndo,
} from "../Editor"
import { EditorToolbarGroup, EditorToolbarItem } from "./EditorToolbar"
import { HistoryIcon, RedoIcon, UndoIcon } from "./icons"

/** Undo and Redo, from the editor's history. */
const ToolbarHistory = () => {
  const undo = useUndo()
  const redo = useRedo()
  const canUndo = useCanUndo()
  const canRedo = useCanRedo()

  return (
    <EditorToolbarGroup
      label="History"
      icon={<HistoryIcon width={24} height={24} strokeWidth={1.5} />}
      collapseBreakpoint="xl"
    >
      <EditorToolbarItem
        label="Undo"
        icon={<UndoIcon width={24} height={24} />}
        onClick={undo}
        isDisabled={!canUndo}
      />
      <EditorToolbarItem
        label="Redo"
        icon={<RedoIcon width={24} height={24} />}
        onClick={redo}
        isDisabled={!canRedo}
      />
    </EditorToolbarGroup>
  )
}

export default ToolbarHistory
